var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from 'react';
import styled from 'styled-components';
import { TctWindowEventProvider } from '../../context/tct-window-context';
import { WindowConfigProvider } from '../../context/window-config-context';
import { HermesysColors } from './Colors';
import { CommunicationTCT, emptyArrayItems } from './Communication';
import { Configuration } from './Configuration';
import { TCT_CALLOPTIONS, TCT_CHANNELS, TCT_CIPHER, TCT_CONFIG, TCT_CONFIG_CODE, TCT_ENCHANCE, TCT_IE, TCT_MAIN, TCT_MUTE, TCT_OFF, TCT_PHONE, TCT_PHONELIST, TCT_PTT, TCT_UNHOOK, TCT_USER_CONF, TCT_USERS, TCT_USERS_CONF, TCT_USERS_GRP, TCT_USERS_INT, TCT_USERS_PAS, TCT_USERS_TAC } from './Constants';
import DateTime from './DateTime';
import { MainButtonLayout } from './MainButtonLayout';
import { PhoneCall, PhoneList } from './PhoneCall';
import { Settings } from './Settings';
import { SidePaneItem } from './SidePaneItem';
var TCTSizes = {
    main: {
        width: 800,
        height: 500,
    },
};
var onFormatDate = function (moment) { return moment.format('DD-MM-YYYY').toUpperCase(); };
var onFormatUTCTime = function (moment) {
    return moment.utc().format('HH:mm:ss') + " UTC";
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  background: ", ";\n  color: ", ";\n  font-family: Lucida Sans Typewriter;\n"], ["\n  width: ", "px;\n  height: ", "px;\n  background: ", ";\n  color: ", ";\n  font-family: Lucida Sans Typewriter;\n"])), TCTSizes.main.width, TCTSizes.main.height, HermesysColors.main.background, HermesysColors.White);
var ContentContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 92%;\n  margin: 10px;\n  display: flex;\n  justify-content: space-between;\n"], ["\n  height: 92%;\n  margin: 10px;\n  display: flex;\n  justify-content: space-between;\n"])));
var StatusBar = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  border: solid 1px ", ";\n  margin: 3px;\n  padding: 3px;\n  border-radius: 2px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  border: solid 1px ", ";\n  margin: 3px;\n  padding: 3px;\n  border-radius: 2px;\n"])), HermesysColors.main.dimWhite);
var SidePane = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 30%;\n  height: 100%;\n"], ["\n  width: 30%;\n  height: 100%;\n"])));
var MiddlePane = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 40%;\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  align-items: center;\n"], ["\n  width: 40%;\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  align-items: center;\n"])));
export var BottomPane = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  height: 15%;\n  text-align: center;\n  color: ", ";\n  padding: 20px;\n"], ["\n  width: 100%;\n  height: 15%;\n  text-align: center;\n  color: ", ";\n  padding: 20px;\n"])), HermesysColors.main.dimWhite);
var mainWindowButtons = [
    { name: 'INTERNAL', id: TCT_USERS_INT, icons: ['internal'] },
    { name: 'TACTICAL', id: TCT_USERS_TAC, icons: ['tactical'] },
    { name: 'GROUPS', id: TCT_USERS_GRP, icons: ['groups'] },
    { name: 'PAS', id: TCT_USERS_PAS, icons: ['pas'] },
    { name: 'CONFERENCES', id: TCT_USERS_CONF, icons: ['conferences'] },
    { name: 'PHONE', id: TCT_PHONE, icons: ['phone'] },
    { name: '50%', id: TCT_IE, icons: ['P_1', 'ie'] },
    { name: 'CONFIG', id: TCT_CONFIG, icons: ['config'] },
];
var callOptions = [
    { name: 'UNHOOK', id: TCT_UNHOOK, icons: ['unhook'] },
    { name: 'ENHANCE', id: TCT_ENCHANCE, icons: ['up'] },
    { name: 'PTT', id: TCT_PTT, icons: [] },
    { name: 'USERS', id: TCT_USER_CONF, icons: ['conferences'] },
    { name: 'OFF', id: TCT_OFF, icons: ['headphoneoff'] },
    { name: 'MUTE', id: TCT_MUTE, icons: ['microphoneoff'] },
    { name: 'CIPHER', id: TCT_CIPHER, icons: ['cipher'] },
    { name: 'Channels', id: TCT_CHANNELS, icons: [] },
];
var defaultConfig = {
    animate: false,
    isBuilder: false,
};
export default function TCTWindow(props) {
    var windowId = props.windowId, otherData = props.otherData, _a = props.config, config = _a === void 0 ? defaultConfig : _a;
    var size = 6;
    var _b = React.useState(windowId !== null && windowId !== void 0 ? windowId : TCT_MAIN), activeButton = _b[0], setActiveButton = _b[1];
    var _c = otherData.leftTrayEntries, leftTrayEntries = _c === void 0 ? [] : _c, _d = otherData.rightTrayEntries, rightTrayEntries = _d === void 0 ? [] : _d, statusMessage = otherData.statusMessage;
    var leftEmptyLength = emptyArrayItems(leftTrayEntries.length, size);
    var leftEntries = __spreadArrays(leftTrayEntries, new Array(leftEmptyLength).fill(0));
    var rightEmptyLength = emptyArrayItems(rightTrayEntries.length, size);
    var rightEntries = __spreadArrays(rightTrayEntries, new Array(rightEmptyLength).fill(0));
    React.useEffect(function () {
        if (windowId !== activeButton) {
            setActiveButton(windowId !== null && windowId !== void 0 ? windowId : TCT_MAIN);
        }
    }, [windowId]);
    var _e = props.onButtonClick, onButtonClick = _e === void 0 ? function () { } : _e, _f = props.onCallButtonClick, onCallButtonClick = _f === void 0 ? function () { } : _f, _g = props.onCallListItemSelect, onCallListItemSelect = _g === void 0 ? function () { } : _g, _h = props.onMainButtonClick, onMainButtonClick = _h === void 0 ? function () { } : _h, _j = props.onPhoneListClick, onPhoneListClick = _j === void 0 ? function () { } : _j, _k = props.onPhoneButtonClick, onPhoneButtonClick = _k === void 0 ? function () { } : _k, _l = props.onSelectCommunicationUser, onSelectCommunicationUser = _l === void 0 ? function () { } : _l, _m = props.onPhoneListButtonClick, onPhoneListButtonClick = _m === void 0 ? function () { } : _m, _o = props.onConfigButtonClick, onConfigButtonClick = _o === void 0 ? function () { } : _o, _p = props.onSettingsButtonClick, onSettingsButtonClick = _p === void 0 ? function () { } : _p, _q = props.onSettingsActivateButtonClick, onSettingsActivateButtonClick = _q === void 0 ? function () { } : _q;
    var goToMain = function () {
        setActiveButton(TCT_MAIN);
    };
    var setActive = function (id) {
        setActiveButton(id);
    };
    var onCallOptionClick = function (id) { };
    var _onButtonClick = function (key) {
        onButtonClick && onButtonClick(key);
    };
    var _onCallButtonClick = function (key, value) {
        onCallButtonClick && onCallButtonClick(key, value);
    };
    var _onCallListItemSelect = function (key, value, isSelected) {
        onCallListItemSelect && onCallListItemSelect(key, value, isSelected);
    };
    var _onMainButtonClick = function (key) {
        onMainButtonClick && onMainButtonClick(key);
    };
    var _onPhoneButtonClick = function (key) {
        onPhoneButtonClick && onPhoneButtonClick(key);
    };
    var _onSelectCommunicationUser = function (key) {
        onSelectCommunicationUser && onSelectCommunicationUser(key);
    };
    var _onSettingsButtonClick = function (key) {
        onSettingsButtonClick && onSettingsButtonClick(key);
    };
    var _onConfigButtonClick = function (key) {
        onConfigButtonClick && onConfigButtonClick(key);
    };
    var _onPhoneListButtonClick = function (key) {
        onPhoneListButtonClick && onPhoneListButtonClick(key);
    };
    var _onSettingsActivateButtonClick = function (key, value) {
        onSettingsActivateButtonClick && onSettingsActivateButtonClick(key, value);
    };
    var _onPhoneListClick = function (key) {
        onPhoneListClick && onPhoneListClick(key);
    };
    return (React.createElement(TctWindowEventProvider, { value: {
            _onButtonClick: _onButtonClick,
            _onMainButtonClick: _onMainButtonClick,
            _onCallButtonClick: _onCallButtonClick,
            _onCallListItemSelect: _onCallListItemSelect,
            _onPhoneButtonClick: _onPhoneButtonClick,
            _onSelectCommunicationUser: _onSelectCommunicationUser,
            _onSettingsButtonClick: _onSettingsButtonClick,
            _onConfigButtonClick: _onConfigButtonClick,
            _onPhoneListButtonClick: _onPhoneListButtonClick,
            _onSettingsActivateButtonClick: _onSettingsActivateButtonClick,
            _onPhoneListClick: _onPhoneListClick,
        } },
        React.createElement(WindowConfigProvider, { value: config },
            React.createElement(Container, null,
                React.createElement(ContentContainer, null, activeButton !== TCT_CONFIG && activeButton !== TCT_CONFIG_CODE ? (React.createElement(React.Fragment, null,
                    React.createElement(SidePane, null, leftEntries.map(function (item, index) { return (React.createElement(SidePaneItem, { item: item, index: index })); })),
                    React.createElement(MiddlePane, null,
                        React.createElement("div", { style: { height: '15%', width: '100%' } }),
                        activeButton === TCT_MAIN && (React.createElement(MainButtonLayout, { buttonList: mainWindowButtons, onClick: config.isBuilder ? _onButtonClick : _onMainButtonClick })),
                        activeButton === TCT_PHONE && (React.createElement(PhoneCall, { goToMain: goToMain, setActive: setActive })),
                        activeButton === TCT_PHONELIST && (React.createElement(PhoneList, { goToMain: goToMain, phoneList: otherData.phoneList })),
                        activeButton.startsWith(TCT_USERS) && (React.createElement(CommunicationTCT, { list: otherData.communicationList })),
                        activeButton === TCT_IE && React.createElement(Settings, null),
                        activeButton === TCT_CALLOPTIONS && (React.createElement(MainButtonLayout, { buttonList: callOptions, onClick: onCallOptionClick })),
                        React.createElement(BottomPane, null, ![TCT_MAIN, TCT_CALLOPTIONS].includes(activeButton) && (React.createElement(React.Fragment, null,
                            React.createElement("div", { onClick: goToMain, style: { cursor: 'pointer' } }, "PRESS TO BACK"),
                            React.createElement("div", { style: { marginTop: 15 } }, "Available Connections"))))),
                    React.createElement(SidePane, null, rightEntries.map(function (item, index) { return (React.createElement(SidePaneItem, { item: item, index: index })); })))) : (React.createElement(Configuration, { goToMain: goToMain, activeButton: activeButton, setActive: setActive }))),
                React.createElement(StatusBar, null, !!statusMessage ? (statusMessage) : (React.createElement("div", null,
                    React.createElement(DateTime, { isLive: true, onFormat: onFormatDate }),
                    ' ',
                    React.createElement(DateTime, { isLive: true, onFormat: onFormatUTCTime }))))))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map